import Debug from 'debug';
import { customElement, property } from 'lit/decorators.js';
import { LitElement, nothing, PropertyValues } from 'lit';
import { PqdSqlClient } from './pdq-sqlite-client';
import { sqliteBroker } from '../services/SqliteBroker';

const log = Debug('pdq:sqlite:download');
@customElement('pdq-sqlite-download')
export class PdqSqliteDownload extends LitElement  {

  @property({type: String}) database: string | undefined
  @property({type: String}) url: string | undefined
  @property({type: Boolean }) overwrite = true


  render = () => nothing

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
  }

  async refresh(){
    log('refreshing')
    if (!this.url) {
      log(`refresh failed... no url`)
      return
    }
    if (!this.database) {
      log(`refresh failed... no database path / name`)
      return
    }

    const c = new PqdSqlClient(this.database!)
    await c.download(this.url, this.database, this.overwrite)
    await c.open(this.database)
    sqliteBroker.setDatabaseReady(this.database)
  }
}